export default __webpack_public_path__ + "static/media/favicon.5a1066d4.ico";